import { Tab, Tabs } from '@material-ui/core'

import React from 'react'
import { useHistory } from 'react-router'

export enum DealAssociationTabsEnum {
  DealAssociations = 'DealAssociations',
  MasterPairings = 'MasterPairings'
}

interface IDealAssociationTabsProps {
  activeTab: DealAssociationTabsEnum
}

const tabs = [
  {
    id: DealAssociationTabsEnum.DealAssociations,
    label: 'Deal Associations',
    url: '/deal-associations'
  },
  {
    id: DealAssociationTabsEnum.MasterPairings,
    label: 'Master Pairings',
    url: '/deal-associations/master-pairings'
  }
]

export const DealAssociationTabs = (props: IDealAssociationTabsProps) => {
  const history = useHistory()
  return (
    <Tabs
      value={props.activeTab}
      onChange={(_event, newValue) => {
        const selectedTab = tabs.find(tab => tab.id === newValue)
        if (selectedTab) {
          history.push(selectedTab.url)
        }
      }}>
      {tabs.map(tab => (
        <Tab key={tab.id} id={tab.id} label={tab.label} value={tab.id} />
      ))}
    </Tabs>
  )
}
